import type React from 'react';

import { Image, SocialIcon } from '@change/ds-core-ui';
import { InstagramIcon } from '@change/ds-icons';

import type { Platform } from '../../../../shared/constants/platformConfig';
import { SocialContentPreviewLoading } from '../SocialContentPreviewLoading';

type SocialContentPreviewProps = Readonly<{
	shareVisual?: {
		url: string;
		variationName: string;
	};
	isLoading: boolean;
	platform?: Platform;
}>;

export const SocialContentPreview: React.FC<SocialContentPreviewProps> = ({ shareVisual, isLoading, platform }) => {
	if (isLoading || !shareVisual) {
		return <SocialContentPreviewLoading platform={platform} />;
	}

	return (
		<div className="relative h-[174px] w-[136px]">
			<SocialIcon
				aria-label="Instagram"
				icon={<InstagramIcon />}
				size="medium"
				variant="instagram"
				className="absolute -top-3 -right-3 border border-white"
				data-testid="instagram-icon"
			/>
			<Image src={shareVisual.url} alt={shareVisual.variationName} className="h-full w-full rounded-lg object-cover" />
		</div>
	);
};
